
import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { Logo } from "./sidebar/Logo";
import { Navigation } from "./sidebar/Navigation";
import { UserProfile } from "./sidebar/UserProfile";
import { Button } from "./ui/button";
import { useIsMobile } from "@/hooks/use-mobile";

export const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const isMobile = useIsMobile();
  
  // Check if there's a saved state in localStorage
  useEffect(() => {
    const savedState = localStorage.getItem("sidebar-collapsed");
    if (savedState) {
      setCollapsed(savedState === "true");
    }
  }, []);

  // Save the collapsed state to localStorage
  const toggleSidebar = () => {
    const newState = !collapsed;
    setCollapsed(newState);
    localStorage.setItem("sidebar-collapsed", String(newState));
  };

  if (isMobile) {
    return (
      <div className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-lg border-t border-white/20 shadow-lg z-10">
        <div className="flex items-center h-14">
          <div className="px-2 flex-shrink-0">
            <Logo collapsed={true} />
          </div>
          <div className="flex-1 overflow-hidden">
            <Navigation collapsed={true} orientation="horizontal" />
          </div>
          <div className="px-2 flex-shrink-0">
            <UserProfile collapsed={true} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className={cn(
        "glass text-foreground h-screen flex flex-col shadow-lg relative transition-all duration-300 ease-in-out",
        collapsed ? "w-20" : "w-64"
      )}
    >
      <div className="relative">
        <Logo collapsed={collapsed} />
        <Button 
          onClick={toggleSidebar}
          variant="ghost"
          size="icon"
          className={cn(
            "absolute text-foreground h-8 w-8 flex items-center justify-center hover:bg-foreground/5 transition-colors",
            collapsed ? "right-3 top-6" : "right-3 top-6"
          )}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </Button>
      </div>
      <Navigation collapsed={collapsed} />
      <UserProfile collapsed={collapsed} />
    </div>
  );
};
